import { render, staticRenderFns } from "./register.vue?vue&type=template&id=3f67917c&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=3f67917c&prod&lang=less&scoped=true&external"
import style1 from "./register.vue?vue&type=style&index=1&id=3f67917c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67917c",
  null
  
)

export default component.exports